import { faHandHoldingCircleDollar } from '@fortawesome/pro-regular-svg-icons';
import { AmountLineItem, type SupportedIcon } from 'corso-admin-ui';
import { Key } from 'react';
import { useCurrency } from '~/hooks/useCurrency';

export type Fee = {
  id: Key;
  kind: 'shipping' | 'handling';
  amount: number;
  name: string;
};

const feeIcon = {
  shipping: 'fee',
  handling: faHandHoldingCircleDollar,
} as const satisfies Record<Fee['kind'], SupportedIcon>;

export function FeeLineItem({ fee }: { fee: Fee }) {
  const { currencyCode } = useCurrency();
  return (
    <AmountLineItem
      size="sm"
      media={{ icon: feeIcon[fee.kind] }}
      title={fee.name}
      currencyCode={currencyCode}
      amount={fee.amount}
    />
  );
}
